import React, { ReactNode } from 'react';
import { routeConstants } from 'routes';
import { ListTitle, SettingsLayout, SettingsNav, SettingsNavItem } from '../Settings/components';

interface ISettingsUIProps {
  children?: ReactNode;
}

const SiteSettingsScreenLayout: React.FC = ({ children }: ISettingsUIProps) => (
  <SettingsLayout data-cy="settings-layout">
    <SettingsNav data-cy="settings-navigation">
      <ListTitle>Site Settings</ListTitle>
      <SettingsNavItem to={routeConstants.private.settingsCalculator}>Calculator</SettingsNavItem>
      <SettingsNavItem to={routeConstants.private.settingsDaySegments}>Day Segments</SettingsNavItem>
      <SettingsNavItem to={routeConstants.private.settingsIntegrations}>Integrations</SettingsNavItem>
      <SettingsNavItem to={routeConstants.private.settingsWithholdings}>Withholdings</SettingsNavItem>
    </SettingsNav>

    {children}
  </SettingsLayout>
);

export default SiteSettingsScreenLayout;
